import { gql } from "lib/apolloClient";
import { resolvedFieldValueFragment } from "modules/CommonFragments";
import {
  postEvidenceFragment,
  unitPlanEvidenceFragment,
} from "./EvidenceFragments";

export const getUnitPlanFieldsQuery = gql`
  query getUnitPlanFields($id: ID!, $uids: [String!]) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        ...unitPlanFields
      }
    }
  }
  ${unitPlanEvidenceFragment.fields}
`;

export const getUnitPlanEvidencesQuery = gql`
  query getUnitPlanEvidences($id: ID!, $filters: PostUnitPlanFilter) {
    node(id: $id, type: UNIT_PLAN) {
      ... on UnitPlan {
        id
        postsFeed(filters: $filters) {
          totalCount
          pageInfo {
            hasNextPage
            startCursor
            endCursor
          }
          edges {
            node {
              ...postItem
              elementPYP {
                id
                fieldUID
                value
                resolvedMinimalTree {
                  ...resolvedMinimalTreeItem
                }
              }
              __typename
            }
          }
        }
      }
    }
  }
  ${postEvidenceFragment.postEvidence}
  ${resolvedFieldValueFragment.resolvedMinimalTree}
`;

export const getPostCountByLearningGoalQuery = gql`
  query getPostCountByLearningGoal(
    $id: ID!
    $learningGoalFilter: LearningGoalFilter
  ) {
    node(id: $id, type: UNIT_PLAN) {
      ... on UnitPlan {
        id
        learningGoalWisePostCount(filters: $learningGoalFilter) {
          totalCount
          learningGoalWisePosts {
            type
            rootNodeId
            totalCount
            __typename
          }
        }
        postsOnlyTaggedToUnitCount {
          totalCount
        }
        __typename
      }
      __typename
    }
  }
`;
